<template>
  <Modal 
    :id="'cmp-product-groups-unmatched-lines'"
    @cancelled="onCancel"
  >
    
    <template slot="header">{{$t('unmatched_lines')}}</template>

    <template slot="body">

      <p style="color:#828282;">{{ $t('product_import_error') }}</p>
    
      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
                        'margin-right': hRowMarginRight
                    }"
          >
            <th class="dt-table2--column">{{$t('catalog_no')}}</th>
            <th class="dt-table2--column">{{$t('barcode')}}</th>
          
          </tr>
        </thead>
        <tbody class="dt-table2--body">
        <tr
          class="dt-table2--row"
          v-for="(item,index) in unmatchedLines"
          :key="index"
        >
          <td class="dt-table2--column">{{item['catalog_no']}}</td>
          <td class="dt-table2--column">{{item['barcode']}}</td>
         
        </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
        <!-- <button class="dt-button v1 s6" @click="onAddGenre">Add Genre</button> -->
        
    
 
      
    </template>

  </Modal>
</template>

<script>

import InputField from "@/plugins/text-field/input-field";

import Modal from '../../../../dt-plugins/modal/modal';



export default {
  props: {
    unmatchedLines: {
      type: Array,
      default:()=>{
        return [];
      }
    }

  },
  components: {
    InputField,

    Modal
  },
  mixins: [
 
  ],

  data: function() {
    return {
      list: [],

      searchSize: "single",

      
    
     

    
    
    };
  },
  mounted:async function() {
  },
  computed: {

    
    hRowMarginRight: function() {
      if (this.unmatchedLines.length > 380 / 28) {
        return "28px";
      }
    },
  
    external_id: function() {
      return this.$route.query.external_id;
    },

  },
  methods: {


    onCancel: function() {
  
      this.$emit("cancelled", true);
    },

  }
};


</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      //background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
</style>